import * as React from "react"
import { cn } from "../lib/utils.ts"
import { Label as LabelPrimitive } from "radix-ui"

/*
 * A field label: 13 px, weight 500, --fg-muted, above its control. A label that wraps its own
 * switch, radio or checkbox reads as the option's text instead: weight 400, like the
 * Checkbox component's label. Disabled draws the text in --fg-faint (no opacity).
 */
function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-ui font-medium text-fg-muted select-none has-data-[slot=switch]:font-normal has-data-[slot=radio-group-item]:font-normal has-data-[slot=checkbox]:font-normal has-disabled:text-fg-faint group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:text-fg-faint peer-disabled:cursor-not-allowed peer-disabled:text-fg-faint",
        className
      )}
      {...props}
    />
  )
}

export { Label }
